// special coffee page js code


function course_level(){
  
 //var new_button = document.getElementsByClassName("new-btn");
 //new_button.style.visibility = 'hidden';
	$(".new-button-id").show();
  
}
function course_module(){
  
 //var new_button = document.getElementsByClassName("new-btn");
 //new_button.style.visibility = 'visible';
	$(".new-button-id").hide();
  
}